import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const Section = styled("div")(({ theme }) => (props) => ({
  padding: "12px  96px",
  width: '100%',
  textAlign: 'center',
  [theme.breakpoints.down("md")]: {
    padding: "12px",
    width: '100%',
    textAlign: 'center',
  },
  [theme.breakpoints.down("sm")]: {
    padding: "6px  ",
    flexDirection: "column",
    width: '100%',
    textAlign: 'center',
  },
  [theme.breakpoints.down("xs")]: {
    padding: "6px ",
    width: '100%',
    textAlign: 'center',
  },
}));

export const ContentComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  marginTop: "12px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    width: '100%'
  },
}));
export const LinkComp = styled("div")(({ theme }) => (props) => ({
  padding: "0 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px 0",
  },
}));
export const LinkText = styled(Link)(({ theme }) => (props) => ({
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0em",
  display: "flex",
  alignItems: "center",
  gap: "5px",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const UserComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  padding: "16px 10px",
  width: "100%",
  border: "1px solid #e5e5e5",
  flexDirection: "column",
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    justifyContent: "center",
    borderBottom: "1px solid #e5e5e5",
    padding: " 0 0 12px",
  },
}));
export const TextUserComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
}));
export const TextUserInfo = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  justifyContent: "center",
  gap: "5px",
  alignItems: "center",
  // margin: '-12px 0',
}));
export const TextSub = styled("p")(({ theme }) => (props) => ({
  fontSize: "14px",
  //fontWeight: 400,
  //width: '100%',
  padding: '0 0.4rem',
  lineHeight: "",
  letterSpacing: "0em",
  //marginLeft: "1vw",
  textAlign: "left",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.dark,
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));
export const UserImage = styled("div")(({ theme }) => (props) => ({
  width: "96px",
  height: "96px",
  [theme.breakpoints.down("sm")]: {
    width: "85px",
  },
}));

export const TeatcherImage = styled("div")(({ theme }) => (props) => ({
  width: "200px",
  height: "200px",
  marginBottom: "22px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "22px",
    width: "96px",
    height: "96px",
  },
}));
export const Image = styled("img")(({ theme }) => (props) => ({
  width: "100%",
  height: "100%",
  borderRadius: "50%",
}));
export const TextUser = styled("h6")(({ theme }) => (props) => ({
  margin: " 0 1vw",
  fontSize: "20px",
  fontWeight: 700,
  // lineHeight: '0'
  letterSpacing: "0em",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
  textAlign: "center",
}));
export const TextDecoration = styled("h6")(({ theme }) => (props) => ({
  margin: "5px",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0em",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.text.dark,
  textAlign: "center",
}));
// export const TitleRaeteng = styled('p')(({ theme }) => (props) => ({
//     fontSize: '12px',
//     fontWeight: '300',
//     lineHeight: '0',
//     letterSpacing: '0em',
//     display: 'flex',
//     alignItems: 'center',
//     margin: '0',
//     [theme.breakpoints.down('lg')]: {
//         fontSize: '1.2vw'
//     },
//     [theme.breakpoints.down('lg')]: {
//         fontSize: '1.3vw'

//     },
//     [theme.breakpoints.down('sm')]: {
//         fontSize: '10px',
//     }
// }))
export const TextDescription = styled("h6")(({ theme }) => (props) => ({
  fontSize: "12px",
  fontWeight: "300",
  lineHeight: "0",
  letterSpacing: "0em",
  display: "flex",
  alignItems: "center",
  margin: "0 2px",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.2vw",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.3vw",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
  },
}));
export const TextDescriptionTitle = styled("p")(({ theme }) => (props) => ({
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "0",
  letterSpacing: "0em",
  display: "flex",
  alignItems: "center",
  margin: "0",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.2vw",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.3vw",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
  },
}));
export const Div = styled("span")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "start",
  gap: "8px",
  [theme.breakpoints.down("sm")]: {
    gap: "2px",
  },
}));
